import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

export const FeedbackMenu = ({ anchorEl, handleClose }) => {
  return (
    <Menu
      id="feedback-menu"
      getContentAnchorEl={null}
      style={{ left: '60px' }}
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={handleClose}
    >
      <MenuItem
        onClick={() => {
          window.open(process.env.REACT_APP_USER_GUIDE);
        }}
      >
        See user guide
      </MenuItem>
      <MenuItem
        onClick={() => {
          window.open(process.env.REACT_APP_SUPPORT);
        }}
      >
        Contact support
      </MenuItem>
      <MenuItem
        onClick={() => {
          window.open(process.env.REACT_APP_HOW_REPORT_BUG);
        }}
      >
        How to report an issue/bug
      </MenuItem>
    </Menu>
  );
};